import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  PaginationModel,
  EntitiesModel,
  ConverterService,
  SearchConfig,
  OccEndpointsService
} from '@spartacus/core';
import { TableService } from '@spartacus/storefront';
import { UserGroupService } from '@spartacus/organization/administration/core';
import { OrganizationTableType } from '@spartacus/organization/administration/components';
import { getUigBranchesOverview } from '../store/uig-branches.actions';
import { UIG_BRANCHES_NORMALIZER } from '../store/uig-branches.adapter';
import { UigBranchesState } from '../store/uig-branches.reducer';
import { selectUigBranchesOverview } from '../store/uig-branches.selectors';
import { UigListService } from './uig-list.service';
import { Branch } from '../uig-branches/uig-branches.models';
import { UigOrganizationTableType } from '../uig-organization.model';

@Injectable({
  providedIn: 'root',
})
export class UigBranchesListService extends UigListService<Branch> {
  protected uigTableType: UigOrganizationTableType.BRANCHES;
  protected tableType = OrganizationTableType.BRANCHES;
  protected _domainType = 'branches';

  constructor(
    protected tableService: TableService,
    protected userGroupService: UserGroupService,
    protected store: Store<UigBranchesState>,
    protected converter: ConverterService,
    protected endpoints: OccEndpointsService,
    protected httpClient: HttpClient
  ) {
    super(tableService);
  }

  public key(): string {
    return 'name';
  }

  protected load(
    pagination: PaginationModel
  ): Observable<EntitiesModel<Branch>> {
    return this.getList(pagination).pipe(
      filter((list) => Boolean(list)),
      map((raw) => this.convertBranches(raw))
    );
  }

  public getList(params?: SearchConfig): Observable<EntitiesModel<Branch>> {
    this.store.dispatch(getUigBranchesOverview({ params }));
    return this.store.select(selectUigBranchesOverview).pipe(
      filter((data) => data != null)
    ).pipe(this.converter.pipeable(UIG_BRANCHES_NORMALIZER));
  }

  protected convertBranches({
    pagination,
    sorts,
    values,
  }: EntitiesModel<Branch>): EntitiesModel<Branch> {
    const branches: EntitiesModel<Branch> = {
      pagination,
      sorts,
      values: values.map((value: any) => ({
        ...value,
        unit: value.unitUid,
      })),
    };
    return branches;
  }

}
